<rask-button
  class="displayButton"
  color="tertiary"
  [ngbPopover]="popContent"
  [autoClose]="'outside'"
  #popOver="ngbPopover"
  triggers="manual" (click)="openPopover()">
  {{texts.skapaprodmall}}
</rask-button>
<ng-template #popContent>
  <div class="skapa-produktionsmall">
    <form [formGroup]="editForm">
      <rask-input [label]="texts.mallNamn" formControlName="benamning" [required]="true"></rask-input>
      <rask-button color="primary" (click)="saveAsMall()" [disabled]="!canBeSaved">{{commonTexts.save}}</rask-button>
      <rask-button color="secondary" (click)="closePopover()">{{commonTexts.cancel}}</rask-button>
      @if (validationContext) {
        <div class="feedback-panel">
          @for (error of validationContext.errors; track error) {
            <small class="text-danger feedback-item">{{error}}</small>
          }
        </div>
      }
    </form>
  </div>
</ng-template>
